// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../common/temp/node_modules/.pnpm/css-loader@7.1.2_webpack@5.99.5/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../common/temp/node_modules/.pnpm/css-loader@7.1.2_webpack@5.99.5/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.stacButtons {
  --tw-bg-opacity: 1;
  background-color: rgb(83 90 164 / var(--tw-bg-opacity, 1));
  border-radius: 0.25rem;
  padding-left: 1.5rem;
  padding-right: 1.5rem;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  font-family: Open Sans;
  font-weight: 600;
  font-size: 16px;
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}

.StacCard {
    border-radius: 0.5rem;
    color: black;
    /* background: white; */
    text-align: left;
    padding: 0.5rem;
}

.StacCollectionCard {
    border: 1px solid black;
    border-radius: 0.5rem;
    padding: 0.1rem;
}

.StacCollectionCard h2 {
    font-size: 1.1em;
}

.StacHeader {
    display: flex;
    justify-content: space-between;
    padding-bottom: 0.5rem;
}

.StacNavigationSelector {
    align-self: center;
}

.StacSearchFilters {
    display: grid;
    grid-template-columns: 35% 15% 30% 10% 10%;
    gap: 0.25em;
}
.StacSearchFilters > * {
    margin-left: 0.2rem;
    margin-right: 0.2rem;
}

.StacSearchResults {
    margin-top: 0.5rem;
    overflow-y: auto;
    max-height: 31.5rem;
}

.StacSearchPagingButtons {
    display: flex;
    justify-content:space-evenly ;
    margin: 0.5rem;
}

.StacCollectionInfo {
    border: 1px solid white;
    padding: 0.5rem;
    padding-left: 1rem;
}
.StacSearchErrorInput {
    border: 1px solid red;
    color: red;
}
.StacScroll {
    overflow-y: auto;
    max-height: 37rem;
}
.StacScroll-hidden {
    display: none;
}

.StacFeature {
    border: 1px solid black;
    display: grid;
    justify-items: center;
    align-items: center;
    grid-template-columns: 15% 85%;
    grid-template-rows: 1fr;
    margin: 0.5rem;
}
.stacFeatureThumbnail {
    height: 100%;
    width: 100%;
}

.stacFeatureAssetSelectionDiv {
    display: grid;
    grid-template-columns: 50% 2% 6rem;
}

.dialog-backdrop {
    grid-column: 1/6;
}

.dialog-content {
    display: grid;
    grid-template-columns: 30% 70%;
}`, "",{"version":3,"sources":["webpack://./src/core/components/cesium/stac-browser/StacCatalog.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,0DAA0D;EAC1D,sBAAsB;EACtB,oBAAoB;EACpB,qBAAqB;EACrB,mBAAmB;EACnB,sBAAsB;EACtB,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,mDAAmD;AACrD;;AAEA;IACI,qBAAqB;IACrB,YAAY;IACZ,uBAAuB;IACvB,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,uBAAuB;IACvB,qBAAqB;IACrB,eAAe;AACnB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,0CAA0C;IAC1C,WAAW;AACf;AACA;IACI,mBAAmB;IACnB,oBAAoB;AACxB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,6BAA6B;IAC7B,cAAc;AAClB;;AAEA;IACI,uBAAuB;IACvB,eAAe;IACf,kBAAkB;AACtB;AACA;IACI,qBAAqB;IACrB,UAAU;AACd;AACA;IACI,gBAAgB;IAChB,iBAAiB;AACrB;AACA;IACI,aAAa;AACjB;;AAEA;IACI,uBAAuB;IACvB,aAAa;IACb,qBAAqB;IACrB,mBAAmB;IACnB,8BAA8B;IAC9B,uBAAuB;IACvB,cAAc;AAClB;AACA;IACI,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,aAAa;IACb,kCAAkC;AACtC;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,8BAA8B;AAClC","sourcesContent":[".stacButtons {\n  --tw-bg-opacity: 1;\n  background-color: rgb(83 90 164 / var(--tw-bg-opacity, 1));\n  border-radius: 0.25rem;\n  padding-left: 1.5rem;\n  padding-right: 1.5rem;\n  padding-top: 0.5rem;\n  padding-bottom: 0.5rem;\n  font-family: Open Sans;\n  font-weight: 600;\n  font-size: 16px;\n  --tw-text-opacity: 1;\n  color: rgb(255 255 255 / var(--tw-text-opacity, 1));\n}\n\n.StacCard {\n    border-radius: 0.5rem;\n    color: black;\n    /* background: white; */\n    text-align: left;\n    padding: 0.5rem;\n}\n\n.StacCollectionCard {\n    border: 1px solid black;\n    border-radius: 0.5rem;\n    padding: 0.1rem;\n}\n\n.StacCollectionCard h2 {\n    font-size: 1.1em;\n}\n\n.StacHeader {\n    display: flex;\n    justify-content: space-between;\n    padding-bottom: 0.5rem;\n}\n\n.StacNavigationSelector {\n    align-self: center;\n}\n\n.StacSearchFilters {\n    display: grid;\n    grid-template-columns: 35% 15% 30% 10% 10%;\n    gap: 0.25em;\n}\n.StacSearchFilters > * {\n    margin-left: 0.2rem;\n    margin-right: 0.2rem;\n}\n\n.StacSearchResults {\n    margin-top: 0.5rem;\n    overflow-y: auto;\n    max-height: 31.5rem;\n}\n\n.StacSearchPagingButtons {\n    display: flex;\n    justify-content:space-evenly ;\n    margin: 0.5rem;\n}\n\n.StacCollectionInfo {\n    border: 1px solid white;\n    padding: 0.5rem;\n    padding-left: 1rem;\n}\n.StacSearchErrorInput {\n    border: 1px solid red;\n    color: red;\n}\n.StacScroll {\n    overflow-y: auto;\n    max-height: 37rem;\n}\n.StacScroll-hidden {\n    display: none;\n}\n\n.StacFeature {\n    border: 1px solid black;\n    display: grid;\n    justify-items: center;\n    align-items: center;\n    grid-template-columns: 15% 85%;\n    grid-template-rows: 1fr;\n    margin: 0.5rem;\n}\n.stacFeatureThumbnail {\n    height: 100%;\n    width: 100%;\n}\n\n.stacFeatureAssetSelectionDiv {\n    display: grid;\n    grid-template-columns: 50% 2% 6rem;\n}\n\n.dialog-backdrop {\n    grid-column: 1/6;\n}\n\n.dialog-content {\n    display: grid;\n    grid-template-columns: 30% 70%;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
